import {useSelector} from "react-redux";
import shallowEqual from "react-redux/es/utils/shallowEqual";

export function useCompanyApiKeysStateSelector() {
  const {companyApiKeysState} = useSelector(
    (state) => ({companyApiKeysState: state.companyApiKeys}),
    shallowEqual
  )
  return companyApiKeysState
}
